import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "todo-item__text"
}
const _hoisted_2 = { class: "todo-item__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["todo-item",  {'todo-item--done':_ctx.todo.complited}]),
    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleTodo && _ctx.toggleTodo(...args)))
  }, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "todo-item__status" }, [
      _createElementVNode("i", { class: "bi bi-check2" })
    ], -1)),
    (!_ctx.isEditing)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.todo.text), 1))
      : _createCommentVNode("", true),
    (_ctx.isEditing)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editText) = $event)),
          onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.saveEdit && _ctx.saveEdit(...args)), ["enter"])),
          onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveEdit && _ctx.saveEdit(...args)))
        }, null, 544)), [
          [_vModelText, _ctx.editText]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "todo-item__remove-button",
        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeTodo && _ctx.removeTodo(...args)), ["stop"]))
      }, _cache[6] || (_cache[6] = [
        _createElementVNode("i", { class: "bi bi-trash3" }, null, -1)
      ])),
      (!_ctx.isEditing)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "todo-item__edit-button",
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.enableEditing && _ctx.enableEditing(...args)), ["stop"]))
          }, _cache[7] || (_cache[7] = [
            _createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
          ])))
        : _createCommentVNode("", true)
    ])
  ], 2))
}